// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"67a4da8b","857":"f89283eb","977":"6cb79eae"}[chunkId] + ".chunk.js";
};